import { IFilter } from '../../types/filters';
import { WindowsContainer } from '../../containers/advancedFilters/WindowsContainer';

export const windows: IFilter = {
  component: WindowsContainer,
};
